import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ResetPasswordState {
  username: string;
  passResetToken?: string;
}

const initialState: ResetPasswordState = {
  username: "",
};

const resetPasswordSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthData(state, action: PayloadAction<{ username: string; }>) {
      state.username = action.payload.username;
    },
    clearAuthData(state) {
      state.username = "";
    },
    setPassResetToken(state, action: PayloadAction<{ token: string }>) {
      state.passResetToken = action.payload.token
    }
  },
});

export const { setAuthData, clearAuthData, setPassResetToken } = resetPasswordSlice.actions;
export default resetPasswordSlice.reducer;
